@if($transparent()) {
    <div class="fixed-background" appGradientPage></div>
}
<div class="layout-container header" [class.mobile-menu]="$showMenu()">
  <a [touchRouterLink]="localeService.rootRoute" class="logo" [innerHTML]="logoIcon.svgData | safeHtml"></a>
  @if($isCompactView()) {
    @if($showOnlyLogin() || $showOnlyRegister() || $showOnlySupport()) {
      @if($showMenu()) {
         <button appButton class="solid grey square margin-left-auto close"
          (touchClick)="toggleMenu()">
          <app-icon [icon]="closeIcon" class="font-24"></app-icon>
        </button>
      } @else {
         <button appButton class="solid grey square margin-left-auto"
          [ngClass]="$dark() ? 'tdark' : ''"
          (touchClick)="toggleMenu()">
          <app-icon [icon]="menuIcon" class="font-24"></app-icon>
        </button>
      }
    } @else {
      <button appButton class="solid primary margin-left-auto"
        [touchRouterLink]="localeService.getLink(routesEnum.START)">
        {{ 'HEADER_V2.START_NOW' | translate }}
      </button>
      @if($showMenu()) {
         <button appButton class="solid grey square margin-left-md close"
          (touchClick)="toggleMenu()">
          <app-icon [icon]="closeIcon" class="font-24"></app-icon>
        </button>
      } @else {
         <button appButton class="solid grey square margin-left-md"
          [ngClass]="$dark() ? 'tdark' : ''"
          (touchClick)="toggleMenu()">
          <app-icon [icon]="menuIcon" class="font-24"></app-icon>
        </button>
      }
    }
  } @else {
    <div class="actions">
      <a appButton [secondIcon]="angleDownIcon" [class.text-grey-80]="$featuresActive()"
        [ngClass]="$dark() ? 'tdark' : 'tblack'"
        class="solid sm r-lg mw-auto dpw"
        appTip [withPush]="false" [tipUnusable]="false"
        [tipTimeout]="50" [tipHideTimeout]="10"
        [tipClass]="($dark() && !$transparent()) && 'light'"
        [tipData]="features" [customComponent]="tipComponent">
        {{ 'HEADER_V2.FEATURES' | translate }}
      </a>

      <a appButton [secondIcon]="angleDownIcon" [class.text-grey-60]="$extensionActive()"
        [ngClass]="$dark() ? 'tdark' : 'tblack'"
        class="solid sm r-lg mw-auto dpw"
        appTip [withPush]="false" [tipUnusable]="false"
        [tipTimeout]="50" [tipHideTimeout]="10"
        [tipClass]="($dark() && !$transparent()) && 'light'"
        [tipData]="extensions" [customComponent]="tipComponent">
        {{ 'HEADER_V2.EXTENSIONS' | translate }}
      </a>

      <a appButton [ngClass]="$dark() ? 'tdark' : 'tblack'"
        class="solid sm r-lg mw-auto"
        [touchRouterLink]="localeService.getLink(routesEnum.PRICING)"
        [routerLinkActive]="'text-grey-80'">
        {{ 'HEADER_V2.PRICING' | translate }}
      </a>

      <a appButton [ngClass]="$dark() ? 'tdark' : 'tblack'"
        class="solid sm r-lg mw-auto"
        [touchRouterLink]="localeService.getLink(routesEnum.ABOUT)"
        [routerLinkActive]="'text-grey-80'">
        {{ 'HEADER_V2.ABOUT_US' | translate }}
      </a>
    </div>

    <div class="auth-actions">
      @if($showOnlySupport()) {
        <button [appButton]="supportIcon"
          [ngClass]="$dark() ? 'tdark' : 'tblack'"
          class="solid transparent"
          (touchClick)="openSupport()">
          {{ 'HEADER_V2.CONTACT_SUPPORT' | translate }}
        </button>
      } @else if($showOnlyLogin()) {
        <a [appButton]="loginIcon"
          [ngClass]="$dark() ? 'tdark' : 'tblack'"
          class="solid transparent"
          [touchRouterLink]="localeService.getLink(routesEnum.SIGN_IN)">
          {{ 'HEADER_V2.LOG_IN' | translate }}
        </a>
      } @else if($showOnlyRegister()) {
        <a [appButton]="cursorIcon"
          [ngClass]="$dark() ? 'tdark' : 'tblack'"
          class="solid transparent"
          [touchRouterLink]="localeService.getLink(routesEnum.START)">
          {{ 'HEADER_V2.START_FREE' | translate }}
        </a>
      } @else {
        <a [appButton]="loginIcon"
          [ngClass]="$dark() ? 'tdark' : 'grey'"
          class="solid"
          [touchRouterLink]="localeService.getLink(routesEnum.SIGN_IN)">
          {{ 'HEADER_V2.LOG_IN' | translate }}
        </a>
        <a [appButton]="cursorIcon"
          class="solid primary"
          [touchRouterLink]="localeService.getLink(routesEnum.START)">
          {{ 'HEADER_V2.START_FREE' | translate }}
        </a>
      }
    </div>
  }
</div>
@if($showMenu()) {
    <app-mobile-menu></app-mobile-menu>
}